import { Text } from '~/components/ui/Text';
import {
	StyledCenterContainer,
	StyledContainer,
	StyledLoadingText,
	StyledShadow,
} from './LoadingScreen.styled';

const LoadingScreen = ({
	icon,
	text,
	color,
	name,
}: {
	icon: string;
	text: string;
	color: string;
	name: string;
}) => {
	return (
		<StyledContainer>
			<StyledShadow style={{ backgroundColor: color }} />
			<StyledCenterContainer>
				<img src={icon} />
				<Text>{name}</Text>
			</StyledCenterContainer>
			<StyledLoadingText>{text}</StyledLoadingText>
		</StyledContainer>
	);
};

export { LoadingScreen };
